import { useMutation } from "@apollo/client";
import ASSOCIATE_ASSET from "queries/associateCampaignAsset.gql";
import { useState } from "react";
import { logGqlErrorToSentry } from "utils/sentry";

const useAssociateCampaignAsset = () => {
  const [error, setError] = useState();
  const [associateCampaignAssetData, setAssociateCampaignAssetData] = useState();
  const [mutate, { loading }] = useMutation(ASSOCIATE_ASSET, { errorPolicy: "all" });

  return {
    associateCampaignAsset: (assetId, campaignId) => {
      mutate({ variables: { input: { assetId, campaignId } } })
        .then((result) => {
          if (result.errors?.length) {
            logGqlErrorToSentry(result.errors[0], "Onboarding: Could not associate asset", {
              storage_data: JSON.parse(localStorage.getItem("onBoarding")) ?? [],
              asset_id: assetId,
              campaign_id: campaignId,
            });
            setError(result.errors[0]);

            return;
          }

          setAssociateCampaignAssetData(result.data);
        });
    },
    data: associateCampaignAssetData,
    loading,
    error,
  };
};

export default useAssociateCampaignAsset;
